module.exports = __webpack_public_path__ + "img/BG128001319.fab62d7d.png";